export enum PlansCtaTypeEnum {
  NEW = 'Purchase',
  CURRENT = "You're on this plan",
  DOWNGRADE = 'Downgrade to',
  UPGRADE = 'Upgrade to',
  UNABLE = 'Unable to switch',
  SWITCH = 'Switch to',
  NOW = 'now'
}
